// extracted by mini-css-extract-plugin
export default {"controls":"styles_controls__-K4FO","label":"styles_label__qP9gK","button":"styles_button__pEmHw","dark":"styles_dark__EjgJa"};